import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2","key":"svg-0"}],["path",{"d":"M10 12h2m2 -2a2 2 0 0 0 -2 -2m-2 2v6","key":"svg-1"}],["path",{"d":"M17 8h4","key":"svg-2"}],["path",{"d":"M19 8v7","key":"svg-3"}],["path",{"d":"M3 3l18 18","key":"svg-4"}]]

const IconHttpOptionsOff = createReactComponent('outline', 'http-options-off', 'HttpOptionsOff', __iconNode);

export default IconHttpOptionsOff;